import { render, staticRenderFns } from "./UserVideo.vue?vue&type=template&id=6a9024f6&scoped=true&"
import script from "./UserVideo.vue?vue&type=script&lang=js&"
export * from "./UserVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9024f6",
  null
  
)

export default component.exports